// @flow
import * as React from 'react';
import FontAwesome from 'react-fontawesome';
import { tr } from 'react-bootstrap';
import type { Props } from './props';
import style from './style';

const MedicationRow = ({ state, image, name, medication, amount, events, date, time }: Props) => {
  const rowStyle = Object.assign({}, style.rowStyle, style.rowBackgroundAlert);

  return (
    <tr style={!state ? rowStyle : style.rowStyle}>

      <td>
        <img height={60} src={image} alt={name} />
      </td>

      <td style={style.textStyle}>
        {name}
      </td>

      <td style={style.textStyle}>{medication}</td>
      <td style={style.textStyle}>{amount}</td>
      <td style={style.textStyle}>{events}</td>
      <td style={style.textStyle}>{date}</td>
      <td style={style.textStyle}>{time}</td>

      <td style={style.textStyle}>
        <FontAwesome name={(state) ? 'check' : 'warning'} style={(!state ? style.alert : null)} />
      </td>

    </tr>
  );
};

export default MedicationRow;



// WEBPACK FOOTER //
// ./src/scenes/Medication/components/MedicationList/components/MedicationRow/MedicationRow.js